import { EUserAccessType, EType, IPageInfoSchema } from '../repositories/journal/entities/page_info/PageInfoSchema';

export const PageMetaAddQuestionPage: IPageInfoSchema = {
  rubricId: 0,
  category: null,
  metaTitle: '',
  metaDescription: '',
  metaKeywords: '',
  metaImage: '',
  canonicalUrl: '',
  noIndex: false,
  type: EType.Page,
  title: 'Задать вопрос',
  breadCrumbName: 'Задать вопрос',
  breadCrumbParents: ['/magazine/', '/forum-rieltorov/'],
  pathname: '/add-question/',
  audienceAccessType: null,
  userAccessType: EUserAccessType.Authorised,
};
